const CPG_SHEF_IDS = ['local-g'];

export default CPG_SHEF_IDS;
